module.exports = __webpack_public_path__ + "static/media/ua.c1f09fb4.webp";